export default {
  mapCentrCoordinates: [55.76, 37.64],
};



// WEBPACK FOOTER //
// ./src/config.js